/**
 *
 * @ngdoc service
 * @name starter.service:searchFieldsService
 * @description
 *
 *
 *
 * @example
 *
 */
'use strict';

import { Injectable, Inject } from 'ng-metadata/core';
import {getVid} from '../appConfig/appConfigForward';
const clone = require('lodash/clone');

    @Injectable()
    export class SearchFieldsService{

        private _mainSearch:any;
        private _scope:any;
        private _sortby:any;
        private _facets:any;
        private _advancedSearch:boolean;
        private _tab:string;
        private _searchParams: any;
        private _offset: number;
        private _journals:string;
        private _databases :string;
        private _pfilters;
        private _prevSortBy: string;
        private _prevSortByAdvanced: string;
        private _prevOffset: number;
        private _prevFacets:any;
        private _prevPFilters: any;

        constructor(@Inject('$translate') private $translate: ng.translate.ITranslateService) {
            this.searchParams={vid: getVid(), lang: $translate.use()};
            this.facets=[];
            this.prevFacets=[];
        }
        
        public reset(){
            this.mainSearch = undefined;
            this.scope = undefined;
            this.sortby = undefined;
            this.facets = undefined;
            this.prevSortBy = undefined;
            this.prevSortByAdvanced = undefined;
            this.prevOffset = undefined;
            this.prevFacets = undefined;
            this.advancedSearch = undefined;;
            this.tab = undefined;
            this.searchParams = undefined;
            this.offset = undefined;
            this.pfilters = undefined;
            this.journals =undefined;
            this.databases =undefined;
        }

        get mainSearch() {
            return this._mainSearch;
        }

        set mainSearch(mainSearch) {
            this._mainSearch = mainSearch;
        }

        get scope() {
            return this._scope;
        }

        set scope(scope) {
             this._scope = scope;
        }

        get tab() {
            return this._tab;
        }

        set tab(tab) {
            this._tab = tab;
        }

        get sortby() {
            return this._sortby;
        }

        set sortby(sortby) {
            this._sortby = sortby;
            this._searchParams.sortby= sortby;
        }

        get facets(){
            return this._facets;
        }

        set facets(facets){
            this._facets= facets;
        }
        get prevFacets(){
            return this._prevFacets;
        }

        set prevFacets(facets){
            this._prevFacets= facets;
        }

        set prevSortBy(prevSortBy){
            this._prevSortBy= prevSortBy;
        }

        get prevSortBy(){
            return this._prevSortBy;
        }

        set prevSortByAdvanced(prevSortByAdvanced){
            this._prevSortByAdvanced= prevSortByAdvanced;
        }

        get prevSortByAdvanced(){
            return this._prevSortByAdvanced;
        }

        set advancedSearch(advancedSearch){
            this._advancedSearch= advancedSearch;
        }

        get advancedSearch(){
            return this._advancedSearch;
        }
        get offset() {
            return this._offset;
        }
        set offset(offset) {
            this._offset = offset;
        }

        get prevOffset() {
            return this._prevOffset;
        }
        set prevOffset(offset) {
            this._prevOffset = offset;
        }

        get pfilters(){
            return this._pfilters;
        }

        set pfilters(pfilters){
            this._pfilters= pfilters;
        }

        get prevPFilters(): any {
            return this._prevPFilters;
        }

        set prevPFilters(value: any) {
            this._prevPFilters = value;
        }

        set searchParams(searchParams){
            this._searchParams= clone(searchParams); //defensive clone so that we don't change this field by reference
        }

        get searchParams(){
            return this._searchParams;
        }
        get databases(): string {
            return this._databases;
        }

        set databases(value: string) {
            this._databases = value;
        }
        get journals(): string {
            return this._journals;
        }

        set journals(value: string) {
            this._journals = value;
        }

     }







// WEBPACK FOOTER //
// ./src/main/webapp/components/search/search.fields.service.ts